// extracted by mini-css-extract-plugin
export default {"infoWrapper":"TopInfo_infoWrapper__+7yuD","infos":"TopInfo_infos__7HrLm","info":"TopInfo_info__FL0Uv"};